module.exports = __webpack_public_path__ + "img/sell.74c5c06c.png";